import { EType as ELabelType } from '../../../../repositories/developer-card/entities/label/LabelSchema';

export const LABEL_BACKGROUNDS: Record<ELabelType, string> = {
  [ELabelType.Mortgage]: 'primary_10',
  [ELabelType.Sale]: 'primary_10',
  [ELabelType.NewbuildingCount]: 'black_6',
  [ELabelType.Discount]: 'success_10',
  [ELabelType.Bonus]: '#ff7e001a',
};

export const LABEL_COLORS: Record<ELabelType, string> = {
  [ELabelType.Mortgage]: 'primary_100',
  [ELabelType.Sale]: 'primary_100',
  [ELabelType.NewbuildingCount]: 'black_100',
  [ELabelType.Discount]: 'success_100',
  [ELabelType.Bonus]: '#db6f0a',
};
